import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ReportPayload {
  reportable_type: 'user' | 'project' | 'comment';
  reportable_id: number;
  reason: string;
  description?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  /**
   * Envía un nuevo reporte al backend.
   */
  sendReport(payload: ReportPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}/reports`, payload);
  }

  /**
   * Verifica si el usuario actual ya reportó cierto contenido.
   */
  checkReport(
    type: 'user' | 'project' | 'comment',
    id: number,
  ): Observable<{ reported: boolean }> {
    return this.http.get<{ reported: boolean }>(
      `${this.apiUrl}/reports/check`,
      {
        params: {
          reportable_type: type,
          reportable_id: id.toString(),
        },
      },
    );
  }
}
